import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { withSystem, withoutSystem } from '../data/content';
export function BeforeAfter() {
  return <Section eyebrow="Before / After" title="From unpredictable cases to a controlled clinical workflow" data-id="element-42" data-mp="3of84difoyype">
      <div className="grid gap-5 md:grid-cols-2" data-id="element-43" data-mp="3sjftvhtz4ioo">
        <div className="rounded-3xl border border-red-500/25 bg-red-950/20 p-5 sm:p-6" data-id="element-44" data-mp="3epoi02srsmps">
          <h3 className="mb-4 flex items-center gap-2 font-display text-lg text-red-300 sm:text-xl" data-id="element-45" data-mp="3jh6o159nhdhm">
            <XIcon className="h-5 w-5" data-id="element-46" data-mp="34sjvu2yxcr8z" /> Before · Without the system
          </h3>
          <ul className="space-y-3" data-id="element-47" data-mp="39qlp1gq2e6y6">
            {withoutSystem.map(item => <li key={item} className="flex items-start gap-3" data-id="element-48" data-mp="39oitkh657lm2">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-49" data-mp="2vrm0sa6gru2j" />
                <span className="text-sm leading-snug text-white/70" data-id="element-50" data-mp="30p5f1a35w6uh">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-lime/30 bg-lime/[0.06] p-5 sm:p-6" data-id="element-51" data-mp="x6n3ic2xx5oq">
          <h3 className="mb-4 flex items-center gap-2 font-display text-lg text-lime sm:text-xl" data-id="element-52" data-mp="t2p2twxyvmtk">
            <CheckIcon className="h-5 w-5" data-id="element-53" data-mp="171yjsytzykyl" /> After · With the system
          </h3>
          <ul className="space-y-3" data-id="element-54" data-mp="124yb0g5rj43s">
            {withSystem.map(item => <li key={item} className="flex items-start gap-3" data-id="element-55" data-mp="edav0ta1hdga">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime" data-id="element-56" data-mp="9ezk0f80cwwh" />
                <span className="text-sm leading-snug text-white/80" data-id="element-57" data-mp="9gsnxmr8l30s">{item}</span>
              </li>)}
          </ul>
          <p className="mt-5 rounded-2xl bg-black/40 p-3 text-center text-xs font-bold uppercase tracking-wide text-lime sm:text-sm" data-id="element-58" data-mp="jd5gghb1paty">
            Planning → Treatment → Finishing, more predictably
          </p>
        </div>
      </div>

      <SectionCta headline="Move your cases to the right column starting with your next patient." data-id="element-59" data-mp="3msujzg3og9pj" />
    </Section>;
}